import { TYPES } from './types';
import { userService } from '../services/userService';

export const getUsers = () => async (dispatch) => {
  try {
    dispatch({ type: TYPES.ACTION_GET_USERS_LOADING });
    const result = await userService.getUsers();
    const data = result.data.data;
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_USERS_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_USERS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_GET_USERS_FAIL,
      payload: { message: error },
    });
  }
};

export const setUsers = (users) => async (dispatch) => {
  try {
    dispatch({ type: TYPES.ACTION_SET_USERS_LOADING });
    const result = await userService.setUsers(users);
    const data = result.data.data;
    if (data) {
      dispatch({
        type: TYPES.ACTION_SET_USERS_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SET_USERS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_SET_USERS_FAIL,
      payload: { message: error },
    });
    throw error;
  }
}; 